// extracted by mini-css-extract-plugin
export default {"quantityInput":"cartQuantityHandler_quantityInput__S+U9Z"};